import { render } from "./PartnerDailyCashBalance.vue?vue&type=template&id=24dffc96&scoped=true"
import script from "./PartnerDailyCashBalance.vue?vue&type=script&lang=js"
export * from "./PartnerDailyCashBalance.vue?vue&type=script&lang=js"

import "./PartnerDailyCashBalance.vue?vue&type=style&index=0&id=24dffc96&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dffc96"]])

export default __exports__